export default __webpack_public_path__ + "static/media/distortion_sl_active.059395f0.png";